import React, { useState } from "react";
import PropTypes from "prop-types";
import { createTheme } from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { NoThemeLoader } from "components/layout/ApplicationLoader";

export const ThemeContext = React.createContext(null);

const ThemeProvider = (props) => {
  const { defaultTheme, theme, loading, refetch, ...rest } = props;
  const [localState] = useState({ refetch });
  if (loading) return <NoThemeLoader />;
  const availableTheme = createTheme(theme || defaultTheme);
  return (
    <ThemeContext.Provider value={localState.refetch}>
      <MuiThemeProvider theme={availableTheme} {...rest} />
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  defaultTheme: PropTypes.object.isRequired,
  theme: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  refetch: PropTypes.func,
};

export default ThemeProvider;
